export const isEmpty = (value) =>
  [null, undefined, true, false].includes(value) ||
  value.length === 0 ||
  (Object.keys(value).length === 0 && value.constructor === Object);

export const getColorByStatusSunat = (statusSunat) => {
  let color = "default";
  let strOriginal = statusSunat.toUpperCase();

  if (
    strOriginal === "ACEPTADO" ||
    strOriginal === "VALIDADO OK" ||
    strOriginal === "ACTIVO"
  ) {
    color = "green";
  } else if (strOriginal === "OBSERVADO POR OSE") {
    color = "orange";
  } else if (
    strOriginal === "RECHAZADO" ||
    strOriginal === "VALIDADO ERROR" ||
    strOriginal === "INACTIVO"
  ) {
    color = "red";
  } else if (strOriginal === "PENDIENTE DE ENVIO") {
    color = "gray";
  } else if (
    strOriginal === "ACEPTADO CON OBSERVACIONES" ||
    strOriginal === "SIN RESPUESTA"
  ) {
    color = "liliac";
  }
  return color;
};
export const getColorByStatusFlag = (estado) => {
  let color = "default";
  let strOriginal = estado;

  if (
    strOriginal === "ACTIVO"
  ) {
    color = "green";
  } else if (strOriginal == "INACTIVO") {
    color = "red";
  }
  return color;
};
export const getColorByStatus = (status) => {
let color = "default";
  let strOriginal = status?status.toUpperCase():'';
  if (
    strOriginal === "ACE" 
  ) {
    color = "green";
  } else if (strOriginal === "REG") {
    color = "orange";
  } else if (
    strOriginal === "REC" 
  ) {
    color = "red";
  } else if (strOriginal === "PND") {
    color = "gray";
  } 
  return color;
};
export const getColorByStatusRegCompras = (status) => {
  let color = "default";
  let strOriginal = status?status.toUpperCase():'';
  if (
    strOriginal === "FIN" 
  ) {
    color = "green";
  } else if (strOriginal === "PEN" || strOriginal === "ACT") {
    color = "gray";
  } else if (strOriginal === "ERR") {
    color = "red";
  } else if (
    strOriginal === "PRO" 
  ) {
    color = "orange";
  }
  return color;
};
export const getColorByAccionCPE = (accion) => {
  let color = "default";
  let strOriginal = accion?accion.toUpperCase():'';
  if (
    strOriginal === "CON" ||  strOriginal === "ACE"
  ) {
    color = "green";
  } else if (
    strOriginal === "DIS" || strOriginal === "NAC"
  ) {
    color = "red";
  } 
  return color;
};
export const generatePagination = (actualPage, totalPage) => {
  let current = actualPage;
  let last = totalPage;
  let delta = 1;
  let left = current - delta;
  let right = current + delta + 1;
  let range = [];
  let rangeWithDots = [];
  let aux;

  for (let i = 1; i <= last; i++)
    if (i === 1 || i === last || (i >= left && i < right)) range.push(i);

  for (let i of range) {
    if (aux) {
      if (i - aux === 2) rangeWithDots.push(aux + 1);
      else if (i - aux !== 1) rangeWithDots.push("...");
    }
    rangeWithDots.push(i);
    aux = i;
  }
  return rangeWithDots;
};
export const parseMoney = (numberValue, numDecimals = 2) => {
  return numberValue.toFixed(numDecimals).replace(/\d(?=(\d{3})+\.)/g, '$&,')
};

export const readFile = async (file) =>{
  return new Promise((resolve, reject)=>{
      try{
          let reader = new FileReader();
          reader.onload = (e) => {resolve(reader.result)};
          reader.readAsArrayBuffer(file);
      }catch(err){
          reject(err);
      }
  });        
};

export const converJsonTextReq =  (json) =>{
  let jsonRs={};
  for(let att of Object.keys(json)){
    if(json[att] instanceof Object)
    {
      jsonRs[att] = json[att].value;
    }else{
      jsonRs[att] = json[att];
    }
  }
  return jsonRs;   
}
